import React, { useContext } from "react"
import useSWR from "swr"
import Fade from "@material-ui/core/Fade"
/** Service */
import UnitManagementAPI from "services/Dashboard/UnitManagement"
/** Components */
import Table from "components/Table"
import Loader from "components/Loader"
/** Context */
import withMainContext from "context/Dashboard/UnitManagement/categories/main/withContext"
import { Context as ParentContext } from "context/Dashboard/UnitManagement/categories/main/Context"
import tableHeaders from "./tableHeaders"

interface TableAllProps {
  activeFilter: number
}

const TableAll: React.FC<TableAllProps> = () => {
  const { setDownloadData } = useContext(ParentContext)
  /** Methods */
  const fetchResidentsArchived = async () =>
    UnitManagementAPI.getArchivedResidents({
      "is_resident": true
    })

  const { data, isValidating } = useSWR(
    "fetchResidentsArchived",
    fetchResidentsArchived,
    {
      revalidateOnFocus: false
    }
  )

  const tableData = data?.data?._data

  if (isValidating) {
    return <Loader dark />
  }

  return (
    <Fade in={!isValidating} timeout={1500}>
      <div>
        <Table
          data={tableData || []}
          columns={tableHeaders(null, `fetchResidentsArchived`)}
          isFilterable
          action={(values: any) => {
            return (
              values.length !== 0 &&
              setDownloadData &&
              setDownloadData(
                values?.map((i: any) => {
                  return {
                    "Block/Unit No.": i?.unitNumber,
                    "Name": i?.name,
                    "Email": i?.email,
                    "Mobile No.": i?.mobileNumber,
                    "Registered Address": i?.registeredAddress,
                    "Archived by": i?.archivedBy,
                    "Archived date": i?.archivedDate
                  }
                })
              )
            )
          }}
        />
      </div>
    </Fade>
  )
}

export default withMainContext(TableAll)
